import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const dot: SxStyle = {
  position: 'absolute',
  top: 8,
  left: -10,
};
